
import Vue, { PropType } from 'vue';
import CandidateService, { PredefinedSkill } from '~/services/CandidateService';
import {
    CandidateJobBuilder,
    CandidateJobBuilderChangeEvent,
    commonProps,
    setupBuilder,
} from '~/utils/candidate';
import SkillsForm from '../forms/SkillsForm.vue';
import ProfileModal from './ProfileModal.vue';

export default Vue.extend({
    name: 'SkillsModal',
    components: {
        ProfileModal,
        SkillsForm,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        allSkills: {
            type: Array as PropType<PredefinedSkill[]>,
            required: true,
        },

        ...commonProps(),
    },
    data() {
        return {
            builder: null as CandidateJobBuilder | null,
            service: new CandidateService(),

            isLoading: false,
            hasUnsavedChanges: false,
        };
    },
    methods: {
        handleBuilderChange(evt: CandidateJobBuilderChangeEvent) {
            this.hasUnsavedChanges = !evt.empty;
        },
        async handleSave() {
            if (!this.builder || this.builder.isEmpty()) return;
            const request = this.builder.buildRequest();

            this.isLoading = true;
            await this.service
                .updateCandidateProfile(request)
                .then(() => this.$emit('close'))
                .finally(() => (this.isLoading = false));

            this.builder.reset();
        },
    },
    mounted() {
        const builder = setupBuilder.apply(this);
        builder.on('change', this.handleBuilderChange);
    },
    beforeDestroy() {
        if (this.builder) this.builder.off('change', this.handleBuilderChange);
    },
});
